// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    color: #444c55;
}

html {
    height: 100dvh;
}

input,
button,
textarea,
select {
    -webkit-appearance: none;
    appearance: none;
}

p,
li,
dt,
dl {
    line-height: 1.6;
}
p {
    margin: 0 0 1em 0;
}
li {
    list-style-type: none;
}

img {
    border: 0;
    max-width: 100%;
    height: auto;
    vertical-align: bottom;
}

.menu_hover {
    position: relative;
    &::after {
        content: "";
        display: block;
        position: absolute;
        bottom: 5.5;
        left: 50%;
        transform: translateX(-50%);
        height: 2px;
        background-color: #f9f1ff;
        transition: width 300ms;
        width: 0;
    }
    &:hover {
        &::after {
            width: 100%;
            border-radius: 2px;
        }
    }
}

.menu_opened {
    position: relative;
    &::after {
        content: "";
        display: block;
        position: absolute;
        bottom: 5.5;
        left: 50%;
        transform: translateX(-50%);
        height: 2px;
        background-color: #f9f1ff;
        transition: width 300ms;
        width: 100%;
        border-radius: 2px;
    }
}

.menu_click {
    position: relative;
    &::after {
        content: "";
        display: block;
        position: absolute;
        bottom: -4;
        left: 50%;
        transform: translateX(-50%);
        height: 2px;
        background-color: #f9f1ff;
        transition: width 300ms;
        width: 70px;
        border-radius: 2px;
    }
}

/* 削除予定 */
/* .gradation_background_login {
    background-color: rgba(192, 0, 0, 1);
    background-image: linear-gradient(152deg, rgba(192, 0, 0, 1), rgba(188, 140, 140, 0.7));
} */

.info {
    position: relative;
    height: auto;
}

.info::before {
    content: "";
    position: absolute;
    left: 0;
    width: 11px;
    height: 100%;
    background-color: #d23f3f;
}

.dot {
    position: relative;
}

.dot::before {
    content: "・";
    position: absolute;
    color: #c00000;
    font-weight: bold;
    top: 50%;
    transform: translateY(-50%);
    left: -10px;
    font-size: 40px;
}

.ellipses {
    overflow-y: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
}

.ellipses2 {
    overflow-y: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}

.line-clamp-2 {
    -webkit-line-clamp: 2;
}

.line-clamp-3 {
    -webkit-line-clamp: 3;
}

.line-clamp-4 {
    -webkit-line-clamp: 4;
}

.skill_animation {
    animation-name: skill;
    animation-duration: 0.6s;
}

@keyframes skill {
    0% {
        opacity: 0;
        transform: translateY(-30px);
    }
    100% {
        opacity: 1;
        transform: translateY(0px);
    }
}

/* ↓↓↓ 不要？ 要確認！：コード整理する際のメモ */
/* .border {
    position: relative;
    font-weight: bold;
}
.border::after {
    content: "";
    width: 100%;
    height: 1px;
    background-color: #333;
    position: absolute;
    bottom: -2;
    left: 0;
    transform: scale(0, 1);
    transition: 0.4s;
    transform-origin: left top;
} */
/* ↑↑↑ 不要？ 要確認！：コード整理する際のメモ */

/* ↓ react-slickのSliderコンポーネントのカスタマイズ ↓ */
.slick-next:before {
    color: #444c55;
    font-size: 40px !important;
}

.slick-prev:before {
    color: #444c55;
    font-size: 40px !important;
}
.slick-prev {
    z-index: 10;
    top: 47px;
}

.slick-next {
    z-index: 10;
    top: 47px;
    right: -10px;
}

.slick-prev.slick-disabled,
.slick-next.slick-disabled {
    display: none !important;
}

.slick-slide {
    padding: 10px;
}

.slick-dots {
    bottom: 0;
    font-size: 40px;
}

.slick-dots li button:before {
    font-size: 15px !important;
}
.slick-dots li.slick-active button:before {
    color: #cc0022 !important;
}

/* ↑ react-slickのSliderコンポーネントのカスタマイズ ↑ */
@media (orientation: landscape) {
    .landscape-margin {
        margin-top: 100px;
        margin-bottom: 100px;
    }
}

/* @supports (-webkit-touch-callout: none) {
    .fill-available {
        height: -webkit-fill-available;
    }
} */
`, "",{"version":3,"sources":["webpack://./src/css/common.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;IAII,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;;;;IAII,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB;QACI,WAAW;QACX,cAAc;QACd,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,2BAA2B;QAC3B,WAAW;QACX,yBAAyB;QACzB,uBAAuB;QACvB,QAAQ;IACZ;IACA;QACI;YACI,WAAW;YACX,kBAAkB;QACtB;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB;QACI,WAAW;QACX,cAAc;QACd,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,2BAA2B;QAC3B,WAAW;QACX,yBAAyB;QACzB,uBAAuB;QACvB,WAAW;QACX,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB;QACI,WAAW;QACX,cAAc;QACd,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,2BAA2B;QAC3B,WAAW;QACX,yBAAyB;QACzB,uBAAuB;QACvB,WAAW;QACX,kBAAkB;IACtB;AACJ;;AAEA,SAAS;AACT;;;GAGG;;AAEH;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;IACvB,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;IACvB,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,0BAA0B;IAC9B;AACJ;;AAEA,6BAA6B;AAC7B;;;;;;;;;;;;;;;GAeG;AACH,6BAA6B;;AAE7B,yCAAyC;AACzC;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,SAAS;IACT,YAAY;AAChB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;AACA;IACI,yBAAyB;AAC7B;;AAEA,yCAAyC;AACzC;IACI;QACI,iBAAiB;QACjB,oBAAoB;IACxB;AACJ;;AAEA;;;;GAIG","sourcesContent":["* {\r\n    margin: 0;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n    color: #444c55;\r\n}\r\n\r\nhtml {\r\n    height: 100dvh;\r\n}\r\n\r\ninput,\r\nbutton,\r\ntextarea,\r\nselect {\r\n    -webkit-appearance: none;\r\n    appearance: none;\r\n}\r\n\r\np,\r\nli,\r\ndt,\r\ndl {\r\n    line-height: 1.6;\r\n}\r\np {\r\n    margin: 0 0 1em 0;\r\n}\r\nli {\r\n    list-style-type: none;\r\n}\r\n\r\nimg {\r\n    border: 0;\r\n    max-width: 100%;\r\n    height: auto;\r\n    vertical-align: bottom;\r\n}\r\n\r\n.menu_hover {\r\n    position: relative;\r\n    &::after {\r\n        content: \"\";\r\n        display: block;\r\n        position: absolute;\r\n        bottom: 5.5;\r\n        left: 50%;\r\n        transform: translateX(-50%);\r\n        height: 2px;\r\n        background-color: #f9f1ff;\r\n        transition: width 300ms;\r\n        width: 0;\r\n    }\r\n    &:hover {\r\n        &::after {\r\n            width: 100%;\r\n            border-radius: 2px;\r\n        }\r\n    }\r\n}\r\n\r\n.menu_opened {\r\n    position: relative;\r\n    &::after {\r\n        content: \"\";\r\n        display: block;\r\n        position: absolute;\r\n        bottom: 5.5;\r\n        left: 50%;\r\n        transform: translateX(-50%);\r\n        height: 2px;\r\n        background-color: #f9f1ff;\r\n        transition: width 300ms;\r\n        width: 100%;\r\n        border-radius: 2px;\r\n    }\r\n}\r\n\r\n.menu_click {\r\n    position: relative;\r\n    &::after {\r\n        content: \"\";\r\n        display: block;\r\n        position: absolute;\r\n        bottom: -4;\r\n        left: 50%;\r\n        transform: translateX(-50%);\r\n        height: 2px;\r\n        background-color: #f9f1ff;\r\n        transition: width 300ms;\r\n        width: 70px;\r\n        border-radius: 2px;\r\n    }\r\n}\r\n\r\n/* 削除予定 */\r\n/* .gradation_background_login {\r\n    background-color: rgba(192, 0, 0, 1);\r\n    background-image: linear-gradient(152deg, rgba(192, 0, 0, 1), rgba(188, 140, 140, 0.7));\r\n} */\r\n\r\n.info {\r\n    position: relative;\r\n    height: auto;\r\n}\r\n\r\n.info::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 0;\r\n    width: 11px;\r\n    height: 100%;\r\n    background-color: #d23f3f;\r\n}\r\n\r\n.dot {\r\n    position: relative;\r\n}\r\n\r\n.dot::before {\r\n    content: \"・\";\r\n    position: absolute;\r\n    color: #c00000;\r\n    font-weight: bold;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    left: -10px;\r\n    font-size: 40px;\r\n}\r\n\r\n.ellipses {\r\n    overflow-y: hidden;\r\n    display: -webkit-box;\r\n    text-overflow: ellipsis;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-line-clamp: 1;\r\n}\r\n\r\n.ellipses2 {\r\n    overflow-y: hidden;\r\n    display: -webkit-box;\r\n    text-overflow: ellipsis;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-line-clamp: 2;\r\n}\r\n\r\n.line-clamp-2 {\r\n    -webkit-line-clamp: 2;\r\n}\r\n\r\n.line-clamp-3 {\r\n    -webkit-line-clamp: 3;\r\n}\r\n\r\n.line-clamp-4 {\r\n    -webkit-line-clamp: 4;\r\n}\r\n\r\n.skill_animation {\r\n    animation-name: skill;\r\n    animation-duration: 0.6s;\r\n}\r\n\r\n@keyframes skill {\r\n    0% {\r\n        opacity: 0;\r\n        transform: translateY(-30px);\r\n    }\r\n    100% {\r\n        opacity: 1;\r\n        transform: translateY(0px);\r\n    }\r\n}\r\n\r\n/* ↓↓↓ 不要？ 要確認！：コード整理する際のメモ */\r\n/* .border {\r\n    position: relative;\r\n    font-weight: bold;\r\n}\r\n.border::after {\r\n    content: \"\";\r\n    width: 100%;\r\n    height: 1px;\r\n    background-color: #333;\r\n    position: absolute;\r\n    bottom: -2;\r\n    left: 0;\r\n    transform: scale(0, 1);\r\n    transition: 0.4s;\r\n    transform-origin: left top;\r\n} */\r\n/* ↑↑↑ 不要？ 要確認！：コード整理する際のメモ */\r\n\r\n/* ↓ react-slickのSliderコンポーネントのカスタマイズ ↓ */\r\n.slick-next:before {\r\n    color: #444c55;\r\n    font-size: 40px !important;\r\n}\r\n\r\n.slick-prev:before {\r\n    color: #444c55;\r\n    font-size: 40px !important;\r\n}\r\n.slick-prev {\r\n    z-index: 10;\r\n    top: 47px;\r\n}\r\n\r\n.slick-next {\r\n    z-index: 10;\r\n    top: 47px;\r\n    right: -10px;\r\n}\r\n\r\n.slick-prev.slick-disabled,\r\n.slick-next.slick-disabled {\r\n    display: none !important;\r\n}\r\n\r\n.slick-slide {\r\n    padding: 10px;\r\n}\r\n\r\n.slick-dots {\r\n    bottom: 0;\r\n    font-size: 40px;\r\n}\r\n\r\n.slick-dots li button:before {\r\n    font-size: 15px !important;\r\n}\r\n.slick-dots li.slick-active button:before {\r\n    color: #cc0022 !important;\r\n}\r\n\r\n/* ↑ react-slickのSliderコンポーネントのカスタマイズ ↑ */\r\n@media (orientation: landscape) {\r\n    .landscape-margin {\r\n        margin-top: 100px;\r\n        margin-bottom: 100px;\r\n    }\r\n}\r\n\r\n/* @supports (-webkit-touch-callout: none) {\r\n    .fill-available {\r\n        height: -webkit-fill-available;\r\n    }\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
